import { useQuery } from "@tanstack/react-query";
import { getDemoStatus } from "../api/api";

export function useDemoStatus() {
  return useQuery({
    queryKey: ["demo-status"],
    queryFn: getDemoStatus,
    staleTime: Infinity,
    retry: false,
  });
}
